$(document).ready(function(){

  if( typeof Handlebars !== 'undefined'){
  
    if( typeof $('.addToCartMessage')[0] == 'undefined' ){
      $('body').append($('<div class="addToCartMessage"></div>'));
    }
    
   
    /*var purchaseHTML = `
    <div class="purchased-item">
      <div class="atc-head"><h3>You added</h3></div>
      <div class="purchase-information">
        <div class="image"><div class="image-container"><img src="{{ featured_image.url }}" /></div></div>
        <div class="title-container">
          <h4>{{ title }}</h4>
          <h5>({{ quantity }} in cart)</h5>
        </div>
      </div>
      <div class="atc-footer">
        <h3>Cart summary</h3> 
        <p>Qty: {{cartQty}}</p>
        <p>Total: {{cartTotal}}</p>
      </div>
    </div>`;*/
    var purchaseHTML = `
    <div class="purchased-item">
      <div class="atc-head"><h3>You added</h3></div>
      <div class="purchase-information">
        <div class="image"><div class="image-container"><img src="{{ image }}" /></div></div>
        <div class="title-container">
          <h4>{{ title }}</h4>
        </div>
      </div>
    </div>`;    
  
    var purchaseTemplate = Handlebars.compile(purchaseHTML);
    
    $('body').on('triggerEventMessage:purchase', function(event, items, allData){
      items.allCartInfo = allData;
      if( typeof Shopify !== 'undefined' ){
          items.cartTotal = Shopify.formatMoney( allData.total_price, "£{{  amount }}");
          items.cartQty = allData.item_count;
      }
      if ( typeof imgFunctionsATC !== 'undefined' && typeof imgFunctionsATC.getSizedImageUrl !== 'undefined'){
        var image_src = items.image;
        image_src = imgFunctionsATC.getSizedImageUrl(image_src, 'x150');
        items.image = image_src;
      }
      
      $('body').find('.addToCartMessage').html( purchaseTemplate(items) );
      $('body').find('.addToCartMessage').addClass('show-notification');
    });

  }
  
  $('body').on('click', '[data-add-to-cart]', function(){
    /* Add to cart */
    var currentAddToCartBtn = $(this);
    if($('body').hasClass('atc-working')){
      return false;
    }
    var product_info = {};
    
    if( typeof $(this).closest('.add-to-cart-item')[0] !== 'undefined' ){
      product_info.id = $(this).closest('.add-to-cart-item').find('*[name="atc-id"]').val();
      product_info.quantity = $(this).closest('.add-to-cart-item').find('*[name="atc-qty"]').val();
      $(currentAddToCartBtn).addClass('working');
        $('body').find('.addToCartMessage').removeClass('show-notification');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: product_info,
        success: function(items){
          $.getJSON('/cart.js', function(allData){
            $('body').trigger('triggerEventMessage:purchase', [items, allData]);
            if( allData.item_count > 0 ){
              $('.nspcc-2019-cart').removeClass('empty');
            }
            $('.cart-count').html( allData.item_count );
          });
        },
        error: function(e){
          console.log(e.description);
        },
        complete: function(){
          $('body').removeClass('atc-working');
        }
      });        
    }
    /* Trigger quick buy notification */    
    
  });
});